import React from "react";

import clsx from "clsx";

type StickyFooterProps = {
	children: React.ReactNode;
	isVisible?: boolean;
};

export function StickyFooter({
	isVisible = true,
	children,
}: StickyFooterProps) {
	return (
		<div
			className={clsx(
				`sticky bottom-0 transition-opacity`,
				isVisible ? "visible opacity-100" : "invisible opacity-0",
				`z-footer`,
			)}
			aria-hidden={!isVisible}
		>
			{children}
		</div>
	);
}
